import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";
import { PaginationButtonGroup } from "./pagination-button-group";

interface TablePaginationProps {
  pageSize: number;
  currentPage: number;
  totalPages: number;
  totalRecords: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (size: number) => void;
  data: any[];
  className?: string;
}

export const TablePagination = ({
  pageSize,
  currentPage,
  totalPages,
  totalRecords,
  onPageChange,
  onPageSizeChange,
  data,
  className,
}: TablePaginationProps) => {
  return (
    <div
      className={`${className} flex flex-wrap items-center min-w-[800px] BookEZ_font_light_bold BookEZ_font_color_gray_2 BookEZ_table_bg_odd_stripe_color border-x border-b BookEZ_table_border_color justify-between px-4 py-5 gap-4 rounded-bl-[12px] rounded-br-[12px]`}
    >
      <div>
        Showing {data?.length} of {totalRecords}
      </div>
      <div className="flex items-end gap-2">
        <div>
          <div className="flex items-center space-x-2">
            <p className="BookEZ_font_body_size">Rows per page</p>
            <Select
              value={pageSize.toString()}
              onValueChange={(newSize: string) => {
                const size = Number(newSize);
                onPageSizeChange && onPageSizeChange(size);
              }}
            >
              <SelectTrigger className="h-8 w-[70px] !rounded-md BookEZ_card_border_color">
                <SelectValue placeholder={pageSize.toString()} />
              </SelectTrigger>
              <SelectContent side="top">
                {[10, 20, 30, 40, 50].map((size) => (
                  <SelectItem key={size} value={size.toString()}>
                    {size}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="flex gap-4 justify-center items-center">
          <div className="flex items-center justify-center BookEZ_font_body_size BookEZ_font_normal">
            Page {currentPage} of {totalPages}
          </div>
          <PaginationButtonGroup
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </div>
  );
};
